var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHips1Male(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 112,
    viewBox: "0 0 91 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1627_9739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9876 29.7588C15.9876 29.7588 18.5718 35.6412 46.9557 35.6412C73.7297 35.6412 75.7692 30.364 75.7692 30.364C75.7692 30.364 77.6454 45.9658 77.1975 46.7707C76.7497 47.5756 76.7497 63.9884 76.7497 63.9884L75.8116 76.7579C75.8116 76.7579 73.9899 79.1847 63.0963 78.9184C52.2028 78.6521 47.0343 74.8818 47.0343 74.8818L46.6228 67.9463L44.0023 67.4864L43.2276 74.3432C43.2276 74.3432 39.8688 78.1135 25.4469 77.5688C14.753 77.1634 14.6985 74.6458 14.6985 74.6458L14.2446 41.324L15.9997 29.7588H15.9876Z",
    fill: "#909091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2399 -39.3567C13.488 -37.4867 12.4592 -32.627 12.9312 -29.4739C13.6151 -24.8442 14.2203 -20.7894 14.9466 -16.9646C16.9498 -6.48274 17.0284 -6.59773 18.0391 0.924786C18.8683 7.09168 18.6746 10.1781 17.8394 13.7004C16.9982 17.2165 16.2114 20.5027 15.9209 26.3428C15.8483 27.765 15.8846 28.9391 15.9209 29.7076C12.9312 42.2835 14.5048 57.6735 14.7468 77.1788C14.7468 77.1788 15.6486 105.962 15.691 111.741",
    stroke: "black",
    strokeWidth: 0.310143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2937 112C38.3528 103.727 39.245 101.268 40.2207 91.5108C40.3296 84.8416 43.2579 74.0379 43.9963 67.4837C44.3534 67.6471 44.8073 67.8045 45.3398 67.8892C46.877 68.1313 48.1298 67.629 48.7047 67.3506",
    stroke: "black",
    strokeWidth: 0.310143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9049 110.049C51.8458 104.911 46.8895 70.761 46.4175 67.9529",
    stroke: "black",
    strokeWidth: 0.310143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2701 -41.4397C77.5001 -37.5483 76.6709 -27.6535 76.5438 -26.3765C75.4424 -15.0776 75.5937 -16.403 73.8325 -6.33865C72.8763 -0.885885 71.908 1.18992 72.7492 7.24182C73.4452 12.2891 75.0611 14.4617 75.7389 21.0946C76.1323 24.9013 76.096 28.0543 76.0052 30.1059C76.4531 31.8247 75.8479 34.9293 76.4107 37.9734C77.8813 45.9256 76.8222 51.9412 76.9493 56.2623C76.9493 56.2623 74.9582 100.241 74.4135 111.74",
    stroke: "black",
    strokeWidth: 0.310143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5056 -82.7285C55.9367 -78.4982 56.1486 -75.0547 56.4875 -72.9789C56.6509 -71.9682 57.0866 -71.012 57.7705 -70.2495C59.114 -68.7547 60.8994 -67.8045 62.9631 -67.1691C63.0478 -67.1449 63.1265 -67.1146 63.2052 -67.0783L71.8777 -63.2656C71.9382 -63.2414 72.0048 -63.2111 72.0653 -63.193C78.1839 -61.1232 78.898 -61.565 81.5488 -60.167C87.2377 -57.1653 90.0882 -46.3808 90.0882 -39.1851C90.0882 -37.7387 89.9913 -37.7689 88.1152 -26.5426C87.0985 -20.4423 86.0878 -14.3722 85.6944 -11.6126C84.1269 -0.586006 85.9849 7.77773 86.4993 14.3077C87.2256 23.4522 87.6976 36.954 83.4733 55.0552C83.9272 59.9875 83.0981 63.9697 83.2736 66.7535C83.4733 69.9792 82.1116 72.2184 81.8635 72.8054C80.3202 76.4608 80.2537 76.6726 78.6378 77.9496L75.8781 79.7288",
    stroke: "black",
    strokeWidth: 0.310143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8409 -82.7285C34.4098 -78.4982 34.198 -75.0547 33.859 -72.9789C33.6956 -71.9682 33.2599 -71.012 32.576 -70.2495L19.074 -63.2656C19.0135 -63.2414 18.9469 -63.2111 18.8864 -63.193C13.0462 -61.22 10.2684 -60.3788 8.79773 -59.8644C2.83046 -57.7765 0.518598 -46.8952 0.10101 -44.2384C-0.20159 -42.3078 -0.401306 -39.8447 1.62611 -26.24C3.01202 -16.9383 3.51434 -15.3648 4.04691 -11.31C5.48729 -0.404448 4.40398 7.45698 3.95613 12.9642C3.21174 22.1571 2.71547 35.8888 6.86714 55.0552C6.41324 59.9875 7.24237 63.9697 7.06686 66.7535C6.86714 69.9792 8.22884 72.2184 8.47697 72.8054C10.0202 76.4608 10.0868 76.6726 11.7027 77.9496L14.8195 79.7288",
    stroke: "black",
    strokeWidth: 0.310143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5759 10.7486C46.4716 9.84686 47.9241 9.84686 48.8319 10.7425",
    stroke: "black",
    strokeWidth: 0.310143,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97607 67.0002L4.53227 108.689",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9761 67.0002L86.5323 108.689",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1627_9739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 112,
    fill: "white",
    transform: "translate(1.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHips1Male);
export default __webpack_public_path__ + "static/media/hips-1-male.f9c452220005f7abadb4c3c0b9dc4028.svg";
export { ForwardRef as ReactComponent };